/*
 * VestiZen page runtime
 * Substitui apenas as partes FUNCIONAIS do antigo core.min.js (Funnelish):
 * videos lazy, FAQ, carrossel (Swiper), sticky "show after", scroll suave e CTAs.
 * Sem analytics, pixels, cookies, geolocalizacao ou chamadas de API.
 */
(function () {
  "use strict";

  var CTA_URL = window.VESTIZEN_PRODUCT_URL || "";

  function setupCtas() {
    document.querySelectorAll("[data-vestizen-cta]").forEach(function (a) {
      if (CTA_URL) a.setAttribute("href", CTA_URL);
      a.addEventListener("click", function (e) {
        if (!CTA_URL) { e.preventDefault(); }
      });
    });
  }

  function setupVideos() {
    var wrappers = document.querySelectorAll(".video-native");
    function load(o) {
      var overlay = o.querySelector(".__video-overlay");
      var ov = overlay ? overlay.querySelector("video") : null;
      var v = overlay ? o.querySelector("video.__video") : o.querySelector("video");
      if (ov && ov.dataset.src) {
        ov.setAttribute("src", ov.dataset.src);
        ov.play && ov.play().catch(function () {});
      } else if (v && v.dataset.src) {
        v.setAttribute("src", v.dataset.src);
        if (v.hasAttribute("autoplay")) v.play && v.play().catch(function () {});
        o.classList.add("loaded");
      }
    }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { load(en.target); io.unobserve(en.target); }
        });
      });
      wrappers.forEach(function (w) { io.observe(w); });
    } else {
      wrappers.forEach(load);
    }
  }

  function setupFaq() {
    document.querySelectorAll(".faq .faq-header").forEach(function (h) {
      var p = h.parentElement;
      h.addEventListener("click", function () { p.classList.toggle("active"); });
    });
  }

  function setupSticky() {
    var els = document.querySelectorAll(".sticky_show_after");
    if (!els.length) return;
    function check() {
      els.forEach(function (el) {
        var n = el.dataset && el.dataset.show_after ? Number(el.dataset.show_after) : 0;
        if (window.scrollY > n) el.classList.add("visible"); else el.classList.remove("visible");
      });
    }
    window.addEventListener("scroll", check, { passive: true });
    check();
  }

  function setupScroll() {
    document.addEventListener("click", function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var el = e.target.closest && e.target.closest("[data-goto-element], a[href^='#']");
      if (!el || el.hasAttribute("data-vestizen-cta")) return;
      var sel = el.getAttribute("data-goto-element") || el.getAttribute("href");
      if (!sel || sel === "#") return;
      var target = document.getElementById(decodeURIComponent(sel.slice(1)));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  function setupCarousels() {
    if (typeof window.Swiper !== "function") return;
    document.querySelectorAll(".carousel").forEach(function (c) {
      try {
        var d = c.dataset;
        var opts = {
          centeredSlides: d.sCenteredSlides,
          keyboard: { enabled: true, onlyInViewport: true },
          direction: d.sDirection,
          slidesPerView: d.sPerViewMobile || d.sPerView || "auto",
          effect: d.sEffect,
          loop: !!d.sLoop,
          initialSlide: d.sInitialSlide,
          rewind: !!d.sRewind,
          speed: d.sSpeed,
          spaceBetween: d.sSpaceBetweenMobile || d.sSpaceBetween || 0,
          pagination: {},
          navigation: {
            nextEl: ".el-" + d.sArrowId + ".swiper-button-next--custom",
            prevEl: ".el-" + d.sArrowId + ".swiper-button-prev--custom"
          },
          breakpoints: {
            600: { slidesPerView: d.sPerViewTablet || d.sPerView || "auto", spaceBetween: d.sSpaceBetweenTablet || d.sSpaceBetween || 0 },
            1024: { slidesPerView: d.sPerView || "auto", spaceBetween: d.sSpaceBetween || 0 }
          }
        };
        if (d.sPaginationId) {
          opts.pagination = { el: ".el-" + d.sPaginationId + " .swiper-pagination", clickable: true };
          var pc = document.querySelector(".el-" + d.sPaginationId + ".swiper-pagination--custom");
          if (pc) {
            var t = pc.dataset.sPaginationType;
            if (t === "default") {
              var inner = pc.querySelector(".swiper-pagination");
              var tpl = inner ? inner.innerHTML.trim() : "";
              if (tpl) opts.pagination.renderBullet = function (i, cls) {
                return '<span class="' + cls + '">' + tpl.replace("index", i + 1) + "</span>";
              };
            } else if (t) {
              if (pc.dataset.sPaginationDynamicBullets) opts.pagination.dynamicBullets = true;
              else opts.pagination.type = t;
            }
          }
        }
        if (d.sAutoplay) opts.autoplay = { delay: d.sAutoplayDelay || 3000, disableOnInteraction: false, pauseOnMouseEnter: d.sPauseOnMouseEnter === "true" };
        if (d.sEffect === "coverflow") opts.coverflowEffect = { rotate: 0, stretch: 100, depth: 150, modifier: 1.5, slideShadows: false };
        var th = c.querySelector("[thumbsslider]");
        if (th) {
          opts.thumbs = {
            swiper: new window.Swiper(".el-" + d.sElement + " .thumbs", {
              spaceBetween: th.dataset.sSpaceBetween || 0, direction: d.sDirection, loop: !!th.dataset.sLoop,
              freeMode: true, centeredSlides: false, slidesPerView: "auto", watchSlidesProgress: true
            })
          };
        }
        new window.Swiper(".swiper_" + d.sElement, opts);
        var wrap = c.querySelector(".swiper .swiper-wrapper");
        var cs = window.getComputedStyle(c);
        var extra = c.querySelector(".swiper-pagination--custom") || c.querySelector(".carousel-wrapper");
        var h = extra ? extra.offsetHeight + "px" : "";
        if (wrap) {
          wrap.style.minHeight = cs.minHeight !== "auto" ? "calc(" + cs.minHeight + " - " + h + ")" : cs.minHeight;
          wrap.style.maxHeight = cs.maxHeight !== "auto" && cs.maxHeight !== "none" ? "calc(" + cs.maxHeight + " - " + h + ")" : cs.maxHeight;
        }
      } catch (err) { console.warn(err); }
    });
  }

  function init() {
    setupCtas();
    setupVideos();
    setupFaq();
    setupSticky();
    setupScroll();
    setupCarousels();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
